import React from 'react';
import { Box, Typography } from '@mui/material';

import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import PanToolIcon from '@mui/icons-material/PanTool';
import FlightIcon from '@mui/icons-material/Flight';
import SportsKabaddiIcon from '@mui/icons-material/SportsKabaddi';
import AdjustIcon from '@mui/icons-material/Adjust';
import AssistantIcon from '@mui/icons-material/Assistant';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import CallMadeIcon from '@mui/icons-material/CallMade';
import GavelIcon from '@mui/icons-material/Gavel';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import BlockIcon from '@mui/icons-material/Block';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import FlagIcon from '@mui/icons-material/Flag';
import SportsMmaIcon from '@mui/icons-material/SportsMma';
import SendIcon from '@mui/icons-material/Send';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import CachedIcon from '@mui/icons-material/Cached';
import ListAltIcon from '@mui/icons-material/ListAlt';

const Tags = [
    {
        title: 'Goalkeeper',
        color: '#10b981',
        categories: [
            { key: 21, id: 'SuperSaved', name: 'Super Saved', icon: PanToolIcon },
            { key: 16, id: 'Saved', name: 'Saved', icon: PanToolIcon },
            { key: 22, id: 'AirChallenge', name: 'Air Challenge', icon: FlightIcon },
            { key: 23, id: 'GroundChallenge', name: 'Ground Challenge', icon: SportsKabaddiIcon },
            { key: 23, id: 'GoalReceive', name: 'Goal Received', icon: AdjustIcon }
        ]
    },
    {
        title: 'Attack',
        color: '#f59e0b',
        categories: [
            { key: 5, id: 'KeyPass', name: 'Key Passes', icon: AssistantIcon },
            { key: 6, id: 'ThroughPass', name: 'Through Passes', icon: TrendingUpIcon },
            { key: 7, id: 'Offside', name: 'Offsides', icon: DoNotDisturbIcon }
        ]
    },
    {
        title: 'Final Third',
        color: '#ef4444',
        categories: [
            { key: 1, id: 'Goal', name: 'Goals', icon: EmojiEventsIcon },
            { key: 2, id: 'GoalOpportunity', name: 'Chances', icon: AdsClickIcon },
            { key: 15, id: 'GoalKick', name: 'Shot on Goal', icon: GpsFixedIcon },
            { key: 3, id: 'Cross', name: 'Crosses', icon: CallMadeIcon },
            { key: 4, id: 'Penalty', name: 'Penalties', icon: GavelIcon }
        ]
    },
    {
        title: '1v1',
        color: '#8b5cf6',
        categories: [
            { key: 17, id: 'Dribble', name: 'Dribbles', icon: DirectionsRunIcon },
            { key: 18, id: 'DrawFoul', name: 'Draw Fouls', icon: ReportProblemIcon },
            { key: 19, id: 'Turnover', name: 'Turnovers', icon: CachedIcon },
            { key: 20, id: 'All', name: 'All Actions', icon: ListAltIcon }
        ]
    },
    {
        title: 'Defense',
        color: '#3b82f6',
        categories: [
            { key: 8, id: 'Interception', name: 'Interceptions', icon: SwapHorizIcon },
            { key: 9, id: 'Tackle', name: 'Tackles', icon: FitnessCenterIcon },
            { key: 10, id: 'Foul', name: 'Fouls', icon: SportsMmaIcon },
            { key: 11, id: 'Blocked', name: 'Blocked', icon: BlockIcon },
            { key: 12, id: 'Clearance', name: 'Clearance', icon: CleaningServicesIcon }
        ]
    },
    {
        title: 'Set Pieces',
        color: '#0ea5e9',
        categories: [
            { key: 13, id: 'Corner', name: 'Corners', icon: FlagIcon },
            { key: 14, id: 'FreeKick', name: 'Free Kicks', icon: SportsSoccerIcon },
            { key: 24, id: 'ThrowIn', name: 'Throw-Ins', icon: SendIcon }
        ]
    }
];

const CategoryCard = ({ category, isSelected, onShow, sectionColor, t }) => {
    const Icon = category.icon || SportsSoccerIcon;

    return (
        <Box
            onClick={onShow(category)}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px 6px',
                borderRadius: '10px',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                backgroundColor: isSelected ? sectionColor : '#f9fafb',
                border: `1px solid ${isSelected ? sectionColor : '#e5e7eb'}`,
                boxShadow: isSelected ? `0 2px 8px ${sectionColor}35` : 'none',
                '&:hover': {
                    borderColor: sectionColor,
                    backgroundColor: isSelected ? sectionColor : `${sectionColor}08`,
                    transform: 'translateY(-1px)'
                },
                minHeight: '54px'
            }}
        >
            <Box
                sx={{
                    width: 26,
                    height: 26,
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: isSelected ? 'rgba(255,255,255,0.2)' : `${sectionColor}12`,
                    marginBottom: '4px'
                }}
            >
                <Icon
                    sx={{
                        fontSize: 15,
                        color: isSelected ? '#ffffff' : sectionColor
                    }}
                />
            </Box>
            <Typography
                sx={{
                    fontSize: '10px',
                    fontWeight: 600,
                    color: isSelected ? '#ffffff' : '#4b5563',
                    textAlign: 'center',
                    lineHeight: 1.1,
                    maxWidth: '100%'
                }}
            >
                {t(category.name)}
            </Typography>
        </Box>
    );
};

const GamePlayerTagButtonList = ({ selectedTag, onShow, t }) => {
    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '8px 20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(6, 1fr)',
                    gap: '8px'
                }}
            >
                {Tags.map((section, sectionIndex) => (
                    <Box
                        key={sectionIndex}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '4px'
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '10px',
                                fontWeight: 700,
                                color: section.color,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                textAlign: 'center',
                                paddingBottom: '2px',
                                borderBottom: `2px solid ${section.color}20`
                            }}
                        >
                            {section.title}
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px'
                            }}
                        >
                            {section.categories.map((category) => (
                                <CategoryCard
                                    key={category.id}
                                    category={category}
                                    isSelected={selectedTag?.id === category.id}
                                    onShow={onShow}
                                    sectionColor={section.color}
                                    t={t}
                                />
                            ))}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default GamePlayerTagButtonList;
